export default {"src":"/_next/static/media/readingBg.864851f8.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};